/**
 * `/settings/agents/models` — RO-10-08 port of `app/settings/agents/models`.
 *
 * The R0 `agents-surfaces` suite asserts Benchmark evidence + the per-seam
 * matrix on this URL. The Next page is a thin SettingsPageShell + client body;
 * this host uses the same client body (moved under client/shared/settings/models)
 * with useApi instead of a server-seeded initial. Live Next page is UNTOUCHED (D6).
 */

import { createRoute } from "@tanstack/react-router";
import { SettingsPageShell } from "@excellent/ui";
import { ModelsSettingsClient } from "../shared/settings/models/_client";
import { rootRoute } from "./__root";

function SettingsAgentsModelsPage() {
  return (
    <SettingsPageShell
      title="Models"
      description={
        <span>
          Connect the AI <strong>model providers</strong> Excellent runs on —
          OpenRouter, a vendor-direct endpoint, or a local runtime like Ollama.
          These apply to <strong>harness / structured</strong> inference paths;
          coding agents (Claude, Grok, Codex, …) and their fallback chain live
          under Coding Agents. Keys are read from your environment or the sealed
          store and are <strong>never written to config</strong>.
        </span>
      }
    >
      <ModelsSettingsClient />
    </SettingsPageShell>
  );
}

export const settingsAgentsModelsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/agents/models",
  component: SettingsAgentsModelsPage,
});
